import React from "react";
import { Box, IconButton, Typography, Tooltip } from "@mui/joy";
import SearchIcon from "@mui/icons-material/Search";
import ListIcon from "@mui/icons-material/List";
import StoreIcon from "@mui/icons-material/Store";
import DownloadIcon from "@mui/icons-material/Download";
import ServicePointsMenu from "./ServicePointsMenu";
import SSENotification from "../../notifications/SSENotification";
import AssignmentExportModal from "./AssignmentExportModal";
import { AppConfigContext } from "../../../contexts/AppConfigContext";
import { textStyles, iconCtaSx } from "../../../theme";

interface AssignmentHeaderProps {
  isSearchMode: boolean;
  onToggleMode: () => void;
}

const AssignmentHeader: React.FC<AssignmentHeaderProps> = ({ isSearchMode, onToggleMode }) => {
  const appConfig = React.useContext(AppConfigContext);
  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [exportModalOpen, setExportModalOpen] = React.useState(false);

  const version = appConfig?.version ? `v.${appConfig.version}` : "v.1.1.2";

  return (
    <>
      <Box
        sx={{
          padding: 2,
          backgroundColor: "neutral.200",
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          alignItems: "center",
          columnGap: 2,
          minHeight: 56,
          flexShrink: 0,
          position: "relative",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography level="h4" sx={textStyles.title}>
            Microstor / SPB
          </Typography>
        </Box>

        <Typography sx={{ ...textStyles.micro, textAlign: "center" }}>{version}</Typography>

        <Box sx={{ display: "flex", alignItems: "center", justifySelf: "end", gap: 1 }}>
          <SSENotification topic="assignments" />
          <Tooltip title="Points de service" placement="bottom">
            <IconButton
              onClick={() => setSettingsOpen(true)}
              variant="plain"
              sx={{
                mr: 1,
                ...iconCtaSx,
              }}
            >
              <StoreIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Exporter CSV" placement="bottom">
            <IconButton
              onClick={() => setExportModalOpen(true)}
              variant="plain"
              sx={{
                mr: 0,
                ...iconCtaSx,
              }}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Vue liste" placement="bottom">
            <IconButton
              onClick={onToggleMode}
              variant={!isSearchMode ? "soft" : "plain"}
              sx={{
                mr: 0,
                ...iconCtaSx,
              }}
            >
              <ListIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Rechercher" placement="bottom">
            <IconButton
              onClick={onToggleMode}
              variant={isSearchMode ? "soft" : "plain"}
              sx={{
                ...iconCtaSx,
              }}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <ServicePointsMenu open={settingsOpen} onClose={() => setSettingsOpen(false)} />

      <AssignmentExportModal open={exportModalOpen} onClose={() => setExportModalOpen(false)} />
    </>
  );
};

export default AssignmentHeader;
